import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcDoneFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.116 6.116a1.25 1.25 0 1 1 1.768 1.768l-11 11a1.25 1.25 0 0 1-1.768 0l-6-6a1.25 1.25 0 1 1 1.768-1.768L10 16.232z"
  }));
}
var IcDoneFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcDoneFill));

export { IcDoneFill as I };
